import { render, staticRenderFns } from "./FontSelect.vue?vue&type=template&id=5f2969c0&scoped=true"
import script from "./FontSelect.vue?vue&type=script&lang=js"
export * from "./FontSelect.vue?vue&type=script&lang=js"
import style0 from "./FontSelect.vue?vue&type=style&index=0&id=5f2969c0&prod&lang=sass&scoped=true"
import style1 from "./FontSelect.vue?vue&type=style&index=1&id=5f2969c0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2969c0",
  null
  
)

export default component.exports